import axiosInstance from 'src/services/common/axiosInstance'

const switchPin = async (id) => {
  if (!id) {
    return ({
      success: false,
      error: {
        id: 400,
        message: 'ブランクID',
        details: { id: 'ブランクID' }
      }
    })
  }

  const res = await axiosInstance.patch(`/characters/${id}/switch_pin`)
  return res.data
}

export default switchPin
